"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpansionPanel = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ExpansionPanelContext_1 = require("./ExpansionPanelContext");
const ExpansionPanelSummary_1 = require("./ExpansionPanelSummary");
const ExpandingDiv_1 = require("../Accordion/ExpandingDiv");
const ExpansionPanel = ({ children, open, onChange, animationProps }) => {
    const [isOpen, setOpen] = (0, react_1.useState)(false);
    const handleOpenChange = (open) => {
        setOpen(open);
        if (onChange)
            onChange(open);
    };
    let summary = null;
    const otherChildren = [];
    react_1.Children.forEach(children, (child) => {
        if (child.type === ExpansionPanelSummary_1.ExpansionPanelSummary) {
            summary = child;
        }
        else {
            otherChildren.push(child);
        }
    });
    const expanded = open !== undefined ? open : isOpen;
    return ((0, jsx_runtime_1.jsx)(ExpansionPanelContext_1.ExpansionPanelContext.Provider, Object.assign({ value: {
            open: expanded,
            setOpen: handleOpenChange
        } }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "expansion-panel" }, { children: [summary, (0, jsx_runtime_1.jsx)(ExpandingDiv_1.ExpandingDiv, Object.assign({}, animationProps, { expanded: expanded }, { children: otherChildren }), void 0)] }), void 0) }), void 0));
};
exports.ExpansionPanel = ExpansionPanel;
//# sourceMappingURL=ExpansionPanel.js.map